<script lang="ts" setup>
import { Media } from "@/types/entity";
import { Overlay } from "vant";
import MediaGroupPreview from "./MediaGroupPreview.vue";

const props = defineProps<{
  show: boolean;
  list: Media[];
  idx: number;
  nextPageFunc: () => Promise<boolean> | boolean;
}>();
const emit = defineEmits<{
  (e: "update:show", val: boolean): void;
  (e: "update:idx", val: number): void;
}>();
</script>
<template>
  <VanPopup
    :show="show"
    safe-area-inset-top
    overlay-class="backdrop-blur-xl flex backdrop-brightness-50"
    class="w-full h-full bg-transparent"
    duration="0"
    teleport="body"
    @update:show="emit('update:show', $event)"
  >
    <MediaGroupPreview
      :idx="idx"
      :list="list"
      :next-page-func="nextPageFunc"
      :show="show"
      @update:idx="emit('update:idx', $event)"
      @update:show="emit('update:show', $event)"
    >
      <template #buttons>
        <slot name="buttons" />
      </template>
      <template #tips>
        <slot name="tips" />
      </template>
    </MediaGroupPreview>
  </VanPopup>
</template>
<style scoped>
.bg-overlay-blue {
  @apply bg-[rgba(13,14,18)];
}
</style>
